module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("iLbqP"))).then(() => parcelRequire('hEqeo'));